import React, { useState, useEffect } from "react";
import moment from "moment";
import { v1 } from "uuid";

import callPostApi from "requests/PostRequests";
import * as Constants from "../../../requests/URLConstants";
import DashboardTable from "../DashboardTable";
import * as DashboardUtils from "../DashboardUtils.js";
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import * as RemediationTables from "./tableHeaders";
import DashboardSummary from "../DashboardSummaryNew";
import DashboardLineChart from "../DashboardLineChart";
import { TableToolbar, TableToolbarContent, TableToolbarSearch, TableToolbarMenu, Checkbox } from 'carbon-components-react';
import * as DashboardConstants from '.././DashboardConstants';
import * as config from "../../../config/Constants";
import * as workspaces from '../../../config/WorkspaceConstants'
require("./_remediation.scss");

const Remediation = (props) => {
    const [RemediationSummaryLoading, setRemediationSummaryLoading] = useState(true);
    const [RemediationTableLoading, setRemediationTableLoading] = useState(true);
    const [RemediationTableData, setRemediationTableData] = useState([]);
    const [RemediationDownloadedData, setRemediationDownloadedData] = useState([]);
    const [RemediationSummaryData, setRemediationSummaryData] = useState([]);
    const [SearchedRemediationTableData, setSearchedRemediationTableData] = useState([]);
    const [ExceptionVsRemediationGraphData, setExceptionVsRemediationGraphData] = useState([]);
    const [ExceptionVsRemediationLoading, setExceptionVsRemediationLoading] = useState(true);
    const [FilteredTableHeaders, setFilteredTableHeaders] = useState([]);

    useEffect(() => {
        getRemediationSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getRemediationTable(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getExceptionVsRemediationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getRemediationTable(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getRemediationDashboardSummary = (param) => {
        let summary = [
            {
                title: DashboardConstants.TotalRuntimeExceptions,
                value: param.runtimeexceptions,
            },
            {
                title: DashboardConstants.SuccessfulAttempts,
                value: param.attempted,
            },
            {
                title: DashboardConstants.Unqualified,
                value: param.unqualified,
            },
            {
                title: DashboardConstants.FailedAttempts,
                value: param.failedattempts,
            },
        ];
        setRemediationSummaryData(summary);
    };

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                filters: {
                    time: {
                        startDateTime: timeFilterSelections.startDateTime,
                        endDateTime: timeFilterSelections.endDateTime,
                    },
                    franchises: franchise,
                    clients: client,
                    technologies: technology,
                    deployment_models:
                        dashboardFilterSelectionsAutomation.deployment_model,
                    assignment_groups: dashboardFilterSelectionsAutomation.assigned_group,
                    business_competencies: dashboardFilterSelectionsAutomation.competency,
                    automata_priority: dashboardFilterSelectionsAutomation.priority,
                    automata_state: dashboardFilterSelectionsAutomation.automata_state,
                    automata_name: dashboardFilterSelectionsAutomation.automata_activity_name,
                    status: dashboardFilterSelectionsAutomation.status,
                    bot_id: dashboardFilterSelectionsAutomation.bot_id,
                    buisness_component: dashboardFilterSelectionsAutomation.buisness_component,
                    process_name: dashboardFilterSelectionsAutomation.process_name,
                    remediation_type: dashboardFilterSelectionsAutomation.remediation_type
                },
                interval: {
                    calender_Interval: calenderInterval,
                    time_zone: timeZone,
                },
                workspace: workspace,
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                filters: {
                    time: {
                        startDateTime: timeFilterSelections.startDateTime,
                        endDateTime: timeFilterSelections.endDateTime,
                    },
                    franchises: franchise,
                    clients: client,
                    technologies: technology,
                    assignment_groups: dashboardFilterSelectionsSAP.assigned_group,
                    incident_status: dashboardFilterSelectionsSAP.incident_status,
                    automata_priority: dashboardFilterSelectionsSAP.priority,
                },
                interval: {
                    calender_Interval: calenderInterval,
                    time_zone: timeZone,
                },
                workspace: workspace,
            };
        }
        return bodyJSON;
    };

    const prepareRemediationSummaryData = (response) => {
        let summaryData = { runtimeexceptions: 0, attempted: 0, unqualified: 0, failedattempts: 0 };
        if (response) {
            let buckets = response.aggregations.Exceptions.buckets
            let statusBucket = buckets["Runtime Exceptions"]["Remediation Records"].buckets;
            summaryData = {
                runtimeexceptions: buckets["Runtime Exceptions"].doc_count,
                attempted: statusBucket.Attempted.doc_count,
                unqualified: statusBucket.Unqualified.doc_count,
                failedattempts: statusBucket["Attempts Failed"].doc_count,
            };
            return { summaryData };
        }
    };

    const getRemediationSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setRemediationSummaryLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETREMEDIATIONEXCEPTIONSUMMARY, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareRemediationSummaryData(resp);
                    getRemediationDashboardSummary(formattedData.summaryData);
                    setRemediationSummaryLoading(false);
                })
                .catch((error) => {
                    setRemediationSummaryLoading(false);
                });
        }
    };
    const handleIncidentClick = (incidentId, client) => {
        let bodyJSON = {
            "incidentId": incidentId,
            "workspace": props.workspace,
            "alertType": "reactive",
            "partyName": client
        };
        const prepareIncidentData = (response) => {
            if (response) {
                let buckets = response.hits && response.hits.hits && response.hits.hits[0]._source ? response.hits.hits[0]._source : '';
                let incidenturl = buckets.incident_url
                let client = buckets.party_name
                var sysid = new URL(incidenturl).searchParams.get("sys_id")
                let incidentpath = `/IncidentDetails?alertType=alert&client=${client}&incidentId=${incidentId}&sysId=${sysid}&workspace=${props.workspace}`
                sysid && window.open(window.location.href.split('/analytics')[0] + incidentpath, "_blank");
                return { sysid, incidentpath };
            }
        }
        callPostApi(Constants.GETCUSTOMFIELDSFORINCIDENTDETAILS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(response => {
                prepareIncidentData(response);
                return response;
            }).catch(error => {
            });
    }

    const prepareRemediationTableData = (response) => {
        let tableData = [];
        let tableObj = {};
        let downloadableData = [];
        let downloadableObj = {};
        if (response) {
            let buckets = response.aggregations[2].buckets;
            for (let i = 0; i < buckets.length; i++) {
                let jobbucket = buckets[i][3].buckets
                for (let j = 0; j < jobbucket.length; j++) {
                    let automatabucket = jobbucket[j][4].buckets
                    for (let k = 0; k < automatabucket.length; k++) {
                        let incidentbucket = automatabucket[k][5].buckets
                        for (let l = 0; l < incidentbucket.length; l++) {
                            let clientbucket = incidentbucket[l][6].buckets
                            for (let m = 0; m < clientbucket.length; m++) {
                                let automatastatusbucket = clientbucket[m][7].buckets
                                for (let n = 0; n < automatastatusbucket.length; n++) {
                                    let typebucket = automatastatusbucket[n][9].buckets
                                    for (let o = 0; o < typebucket.length; o++) {
                                        let durationbucket = typebucket[o][8].buckets
                                        for (let p = 0; p < durationbucket.length; p++) {

                                            let incidentId = <button class="link" onClick={() => handleIncidentClick(incidentbucket[l].key, clientbucket[m].key)}>{incidentbucket[l].key}</button>
                                            tableObj = {
                                                id: ((i + 1).toString()),
                                                'Incident No.': incidentId,
                                                'Client': clientbucket[m].key,
                                                'Process': automatabucket[k].key,
                                                'Job ID': buckets[i].key,
                                                'Associated failure job ID': jobbucket[j].key,
                                                'Type': typebucket[o].key,
                                                'Remediation status': automatastatusbucket[n].key,
                                                'Dur.': (durationbucket[p].key).toFixed(2),
                                                'Updated on': buckets[i][1].value_as_string
                                            }

                                            downloadableObj = {
                                                id: ((i + 1).toString()),
                                                'Incident No.': incidentbucket[l].key,
                                                'Client': clientbucket[m].key,
                                                'Process': automatabucket[k].key,
                                                'Job ID': buckets[i].key,
                                                'Associated failure job ID': jobbucket[j].key,
                                                'Type': typebucket[o].key,
                                                'Remediation status': automatastatusbucket[n].key,
                                                'Dur.': (durationbucket[p].key).toFixed(2),
                                                'Updated on': buckets[i][1].value_as_string
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                tableData = tableData.concat(tableObj);
                downloadableData = downloadableData.concat(downloadableObj);
            }
        }
        console.log(tableData, downloadableData)
        return { tableData, downloadableData };
    };

    const prepareRemediationTableULLData = (resp) => {
        let tableData = [], tableObj = {};
        let downloadableData = [], downloadableObj = {};
        let buckets = resp.aggregations[2].buckets;
        buckets.map((jobItem) => {
            jobItem[4].buckets.map((processItem) => {
                processItem[10].buckets.map((incidentItem) => {
                    incidentItem[6].buckets.map((clientItem) => {
                        clientItem[7].buckets.map((statusItem) => {
                            statusItem[8].buckets.map((typeItem) => {
                                typeItem[9].buckets.map((durationItem) => {
                                    tableObj = {
                                        id: v1(),
                                        'Incident No.': incidentItem.key,
                                        'Client': clientItem.key,
                                        'Process': processItem.key,
                                        'Job ID': jobItem.key,
                                        'Type': typeItem.key,
                                        'Remediation status': statusItem.key,
                                        'Dur.': (durationItem.key).toFixed(2),
                                        'Updated on': jobItem[1].value_as_string
                                    }
                                    downloadableObj = {
                                        id: v1(),
                                        'Incident No.': incidentItem.key,
                                        'Client': clientItem.key,
                                        'Process': processItem.key,
                                        'Job ID': jobItem.key,
                                        'Type': typeItem.key,
                                        'Remediation status': statusItem.key,
                                        'Dur.': (durationItem.key).toFixed(2),
                                        'Updated on': jobItem[1].value_as_string
                                    }
                                })
                            })
                        })
                    })
                })
            })
            tableData = tableData.concat(tableObj);
            downloadableData = downloadableData.concat(downloadableObj);
        })
        return { tableData, downloadableData };
    }

    const getRemediationTable = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setRemediationTableLoading(true);
            let formattedData = [];
            console.log(config.URL);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(config.URL.includes(config.unilever) ? Constants.GETREMEDIATIONALLACTIVITIESULL : Constants.GETREMEDIATIONALLACTIVITIES, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    //console.log(resp);
                    formattedData = config.URL.includes(config.unilever) ? prepareRemediationTableULLData(resp) : prepareRemediationTableData(resp);
                    //formattedData = prepareRemediationTableULLData(resp);
                    setRemediationTableData(formattedData.tableData);
                    setRemediationDownloadedData(formattedData.downloadableData);
                    setRemediationTableLoading(false);
                })
                .catch((error) => {
                    setRemediationTableLoading(false);
                });
        }
    };

    const prepareExceptionVsRemediationData = (response) => {
        let graphData = [];
        let graphObj = {};
        if (response) {
            let buckets = response.aggregations["Time Range"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                let remediationbucket = buckets[i]["Remediation Data"].buckets;
                let groupdata = Object.getOwnPropertyNames(remediationbucket);
                let remediationbucketLength = Object.keys(remediationbucket).length
                for (let j = 0; j < remediationbucketLength; j++) {
                    graphObj = {
                        id: ((i + 1).toString()),
                        date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                        group: groupdata[j],
                        value: remediationbucket[groupdata[j]].doc_count
                    }
                    graphData.push(graphObj);
                }
            };
        }
        return { graphData };
    };

    const getExceptionVsRemediationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setExceptionVsRemediationLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETEXCEPTIONANDREMEDIATIONCOUNT, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareExceptionVsRemediationData(resp);
                    setExceptionVsRemediationGraphData(formattedData.graphData);
                    setExceptionVsRemediationLoading(false);
                })
                .catch((error) => {
                    setExceptionVsRemediationLoading(false);
                });
        }
    };

    const searchTable = (event) => {
        let searchString = event.target.value.toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = RemediationTableData.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        string = element[property] ? element[property] : "";
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            setSearchedRemediationTableData(newList);
        } else {
            setSearchedRemediationTableData(RemediationTableData);
        }
    };

    let headers = config.URL.includes(config.unilever) ? [...RemediationTables.ULLRemediationTableHeaders] : [...RemediationTables.RemediationTableHeaders];
    //let headers = [...RemediationTables.ULLRemediationTableHeaders];
    const manageHeader = (checked, id) => {
        headers.forEach(header => {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        let filteredheader = headers.filter(header => header.hidden === false);
        setFilteredTableHeaders(filteredheader);
    };

    return (
        <div className="top-margin dashboard remediation-dashboard">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={RemediationSummaryLoading} summary={RemediationSummaryData} title={DashboardConstants.RemediationDashboardSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <DashboardLineChart lineGraphData={ExceptionVsRemediationGraphData} loading={ExceptionVsRemediationLoading} title={DashboardConstants.ExceptionVsRemediation} graphTitle={DashboardConstants.TotalTicketsCount} />
                    </section>
                    <section>
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.RemediationAllActivities}</div>
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        <TableToolbarSearch onChange={searchTable} />
                                        <TableToolbarMenu light iconDescription="Headers">
                                            <fieldset className="optional-headers">
                                                {headers.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} /> : null))}
                                            </fieldset>
                                        </TableToolbarMenu>
                                        <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={RemediationDownloadedData} headers={FilteredTableHeaders.length ? FilteredTableHeaders : headers} title={DashboardConstants.Remediation} filename={DashboardConstants.Remediation} label={DashboardConstants.Download} />
                                    </TableToolbarContent>
                                </TableToolbar>
                            </div>
                        </div>
                        <DashboardTable loading={RemediationTableLoading} rows={SearchedRemediationTableData.length ? SearchedRemediationTableData : RemediationTableData}
                            headers={FilteredTableHeaders.length ? FilteredTableHeaders : headers.filter(header => header.hidden === false)} showPagination={true} isSortingAllowed={true} />
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Remediation;
